// Set up your root reducer here...
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import requests from './requests';
import currentUser from './currentUser';

export default combineReducers({
    users: (users = []) => users,
    requests,
    permissions: (permissions = []) => permissions,
    currentUser,
    routing: routerReducer
});



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/